import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Chip from '@material-ui/core/Chip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { CircularProgress } from '@material-ui/core';
import { ErrorIcon } from '@pec/aion-ui-components/components/ErrorIcon';
import { fetchClientRankingsIfNeeded } from 'actions/clientRankings';
import { GridContainer } from '@pec/aion-ui-components/components/GridContainer';
import { IClientWithRanking } from 'interfaces/clientWithRanking';
import { scoreTileStyles } from './ClientScoresTile';
import { toggleClientScoresTileExpandedOrganizationId } from 'actions/options';
import { useAppDispatch, useTypedSelector } from 'combineReducers';
import { useParams } from 'react-router-dom';

interface Props {
  client: IClientWithRanking;
}

type RouteParams = {
  organizationId: string;
};

export const ClientScoresTileAccordionContents: React.FC<Props> = ({ client }) => {
  const dispatch = useAppDispatch();
  const classes = scoreTileStyles();
  const clientRankings = useTypedSelector(state => state.clientRankings[client.id]);
  const rankingIsLoaded =
    clientRankings !== null && clientRankings !== undefined && clientRankings.clientRankings !== null;
  const isFetching = clientRankings !== null && clientRankings !== undefined && clientRankings.isFetching;
  const error = clientRankings !== null && clientRankings !== undefined && clientRankings.error;
  const { organizationId } = useParams<RouteParams>();

  const handleClick = (clientId: string) => () => dispatch(toggleClientScoresTileExpandedOrganizationId(clientId));

  useEffect(() => {
    dispatch(fetchClientRankingsIfNeeded(client.id, organizationId));
  }, [dispatch, organizationId, client.id]);

  return (
    <>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={handleClick(client.id)}>
        <GridContainer spacing={0} justify="space-between">
          <Grid item>
            <Typography variant="h6">{client.name}</Typography>
          </Grid>
          {isFetching ? (
            <Grid item style={{ paddingRight: 34 }}>
              <CircularProgress size={24} />
            </Grid>
          ) : error ? (
            <Grid item style={{ paddingRight: 34 }}>
              <ErrorIcon />
            </Grid>
          ) : (
            <Grid item>
              <Chip
                label={
                  rankingIsLoaded &&
                  clientRankings.clientRankings !== null &&
                  clientRankings.clientRankings.overallRanking.label
                }
                style={{
                  backgroundColor:
                    rankingIsLoaded && clientRankings.clientRankings !== null
                      ? clientRankings.clientRankings.overallRanking.color
                      : 'none'
                }}
                className={classes.chip}
              />
            </Grid>
          )}
        </GridContainer>
      </AccordionSummary>
      {client.isExpanded && clientRankings && (
        <AccordionDetails className={classes.accordionDetails}>
          <TableContainer>
            <Table className={classes.table}>
              <TableBody>
                {rankingIsLoaded &&
                  clientRankings.clientRankings !== null &&
                  clientRankings.clientRankings.moduleRankings
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((moduleRanking: any) => (
                      <TableRow
                        key={
                          rankingIsLoaded && clientRankings.clientRankings !== null
                            ? `${clientRankings.clientRankings.organization.id}-${moduleRanking.name}`
                            : ''
                        }
                      >
                        <TableCell className={classes.tableCell}>
                          <Typography variant="body1">
                            <span
                              style={{
                                color: moduleRanking.color
                              }}
                            >
                              ⬤
                            </span>{' '}
                            {moduleRanking.name}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Typography variant="body1">{moduleRanking.value}</Typography>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      )}
    </>
  );
};
